import React, { useEffect, useState } from "react";

export function LiveClock({ className = "" }) {
  const [time, setTime] = useState(null);

  useEffect(() => {
    const update = () => {
      const t = new Intl.DateTimeFormat("de-DE", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Europe/Berlin",
        hour12: false,
      }).format(new Date());
      setTime(t);
    };
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <span className={`tech-label inline-flex items-center gap-2 ${className}`}>
      <span className="relative flex h-1.5 w-1.5" aria-hidden="true">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[oklch(0.68_0.12_155)] opacity-75" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[oklch(0.68_0.12_155)]" />
      </span>
      <span className="tabular-nums">FRA · {time ?? "--:--:--"} CET</span>
    </span>
  );
}
